var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"neitui"},[_c('c-tab',{attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"operate",fn:function(){return [_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.open}},[_vm._v("查看奖励方案")])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }